import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    fetchCaseDetail,
    fetchCompanyProfile,
    initiateCaseState,
    proceedCase,
    referCase,
    updateCaseType,
    rejectCase,
    assignCase,
    fetchCaseAssociates,
    fetchCaseBankAccounts,
    fetchCaseDetailFields,
    updateCaseAssociateStatus,
    GstinsearchList
} from "actions";
import { ProceedChecklist } from "hocs";
import { Map, List } from "immutable";
import {
    Drawer,
    Layout,
    Button,
    PageHeader,
    Tag,
    Row,
    Col,
    notification,
    Icon,
    Dropdown,
    Menu,
    Modal,
    message,
    Tooltip,
    Input,
    Select,
    DatePicker
} from "antd";
import _capitalize from "lodash/capitalize";
import { SupplyChainRecord, CaseSanctionRecord } from "records";
import CaseDetails from "./tabs";
import { CaseService } from "services";
import { fetchCaseLedgerMasters } from "services/case-service";
import UnderwritingService from "services/underwriting-service";
import CaseDetailsSummary from "./case-details-summary";
import { LoaderSkeleton, DocumentViewer } from "components";
import { CASE_VIEW_ACTION, STATE_STATUS } from "constants";
import { CONSTITUTION_TYPES } from "constants/enums";
import { isSectionVisibleByAuthority } from "constants/user-visibility";
import "styles/case-details.css";
import "styles/drawer-overrides.css";
import { CompanyService } from "../../services";
import { fetchEnums } from "actions";
import { fetchCompanyDocuments, fetchCamEngineView, fetchPortfolioView, fetchCamEngineViewComments, fetchCamEngineStatusLogs } from 'store/actions'
import moment from 'moment';
import { DEFERRAL_CATEGORY } from 'constants/index';

const { TextArea } = Input;
const { Option } = Select;

class CaseDetailsDrawer extends React.Component {
    state = {
        visible: !!this.props.caseId,
        expanded: false,
        isRiskApprover: null,
        action: null,
        takeAction: false,
        showDocuments: false,
        disableActionButton: false,
        documentsList: [],
        case_task_updated: false,
        casesList: new List([]),
        fetchedCasesList: false,
        showSupplyChainRemarks: false,
        are_sellers_same: false,
        ledger_masters: [],
        caseLedgerStatus: null,
        sales_manager_users: [],
        inside_sales_persons: [],
        asm_data: null,
        isp_data: null,
        showPullBackRemark: false,
        showError: false,
        remarksValue: "",
        pullbackloader: false,
        showCaseMovementBtns: {},
        openChecklistModalUnAssign: false,
        groupInfoRefreshKey: 0,
        onChangeReasonUnAssign: "",
        fetchCaseAssocicate: true,
        dbViewTableData: [],
        anchorViewTableData: [],
        geoViewTableData: [],
        stateViewTableData: [],
        camEngineData: [],
        // deferralEndDate: null,
        categoryDeferral: [],
        actionDeferral: "",
        remarksDeferral: "",
        actionReasonsList: [],
        selectedCategories: [],
        deferralCategoryIdMap: {},
        categoryIdMapInactive: [],
        isDeferralUpdating: false
    };
    isLoading() {
        if (this.props.status === STATE_STATUS.FETCHED) {
            return false;
        }
        // Stale-while-revalidate: the reducer keeps `data` populated across a
        // refetch (e.g. Account/Facility edits like Bounce/Pre-payment charges
        // calling fetchCaseDetail after save) instead of blanking it — mirror
        // that here so a refetch doesn't re-hide the whole tab behind this
        // skeleton. Only the very first load (no data yet) should show it.
        if (
            this.props.status === STATE_STATUS.FETCHING &&
            this.props.caseDetail &&
            this.props.caseDetail.get &&
            this.props.caseDetail.get("id")
        ) {
            return false;
        }
        return true;
    }
    getActionModal = action => {
        this.setState({
            disableActionButton: true
        });
        let caseAssociates = this.props.caseAssociates &&
            this.props.caseAssociates.filter(_ => [1, 2].includes(_.type))
                .map(_ => Number(_.company_associate.id));
        let associates = this.props.company &&
            this.props.company.associates &&
            this.props.company.associates.filter(_ => caseAssociates && caseAssociates.includes(Number(_.id)))
                .map(_ => ({
                    id: _.id,
                    name: `${_.first_name || ""} ${_.last_name || ""}`
                }))
                .toList().toArray();
        this.props.history.replace(this.props.location.pathname, {
            ...this.props.location.state,
            case_actions: {
                case_id: this.props.caseId,
                case_task_id: this.props.case_task_id,
                stage_id: this.props.stageId,
                associates,
                companyId: this.props.companyId,
                stageName: this.props.stageName,
                action: action,
                params: this.props.location.pathname,
            }
        });
    };
    closeActionModal = () => {
        this.setState({
            takeAction: false,
            action: null,
            disableActionButton: true
        });
    };

    openDocumentsDrawer = (documents, doc, fileName) => {
        let docsList =
            documents &&
            documents.size &&
            documents.map(_ => (
                {
                    file: _.getIn(["data", "file", "file"]),
                    fileName: _.getIn(["data", "file", "file_name"])
                }
            ));
        this.setState({
            showDocuments: true,
            documentsList: docsList ? docsList : new Map({ fileObj: { file: doc, fileName } })
        });
    };

    closeDocumentsDrawer = () => {
        this.setState({
            showDocuments: false
        });
    };

    upgradeCaseButtonsEnabled = () => {
        this.setState({
            disableActionButton: false
        });
    };

    componentDidMount() {
        if (this.props.caseId) {
            this.props.initiateCaseState(this.props.caseId);
        }
        this.props.fetchEnums();
        if (this.props.caseId && this.props.stageId) {
            this.props.fetchPortfolioView(this.props.caseId, this.props.stageId);
        }
        // this.props.caseId && CompanyService.getCreditEnhancementDbView(this.props.caseId).then(({data}) => {
        //     this.setState({dbViewTableData: data});
        // }).catch((err) => {
        //     // message.error(err?.non_field_error && err?.non_field_error.length && err?.non_field_error[0] || "Something went wrong");
        // });
        // this.props.caseId && CompanyService.getAnchorView(this.props.caseId).then(({data}) => {
        //     this.setState({anchorViewTableData: data && data?.data});
        //     // data && data.message && message.error(data.message);
        // }).catch((err) => {
        //     // message.error(err && Object.values(err) && Object.values(err)[0]|| "Something went wrong");
        // });
        // this.props.caseId && CompanyService.getGeoView(this.props.caseId).then(({data}) => {
        //     this.setState({geoViewTableData: data && data?.data});
        //     // data && data.message && message.error(data.message);
        // }).catch(() => {
        //     // message.error("Something went wrong");
        // });
        // this.props.caseId && CompanyService.getStateView(this.props.caseId).then(({data}) => {
        //     this.setState({stateViewTableData: data});
        //     // data && data.message && message.error(data.message);
        // }).catch(() => {
        //     // message.error("Something went wrong");
        // });


        if (
            this.props.caseId &&
            this.props.action === CASE_VIEW_ACTION
        ) {
            this.props.fetchCaseDetail(this.props.caseId);
        }
        if (
            this.props.caseId &&
            this.props.action === CASE_VIEW_ACTION &&
            (this.props.caseAssociatesStatus === STATE_STATUS.UNFETCHED || !this.props.status)
        ) {
            this.props.fetchCaseAssociates(this.props.caseId);
        }

        if (
            this.props.caseId &&
            this.props.action === CASE_VIEW_ACTION &&
            (this.props.caseBankAccountsStatus === STATE_STATUS.UNFETCHED || !this.props.status)
        ) {
            this.props.fetchCaseBankAccounts(this.props.caseId);
        }

        if (
            this.props.status === STATE_STATUS.FETCHED &&
            this.props.companyStatus &&
            this.props.companyStatus.get("companyStatus") ===
            STATE_STATUS.FETCHED
        ) {
            this.setState({
                visible: true
            });
        }
        // this.handleGuarantorNotification();
        if (
            this.props.userStatus === "FETCHED" &&
            this.state.isRiskApprover === null
        ) {
            let group =
                this.props.user &&
                this.props.user
                    .getIn(["data", "groups"])
                    .filter(_ => _.id == 8);
            this.setState({
                isRiskApprover: (group.size || group.length) ? true : false
            });
        }

        this.props.caseId && CaseService.getCaseLedgerStatus(this.props.caseId).then(({ data }) => {
            this.setState({
                caseLedgerStatus: data.status
            });
        }).catch(() => { });
        this.callAsmList();
        this.callISPList();
        CompanyService.getSMList().then(({ data }) => {
            this.setState({
                sales_manager_users: data
            });
        }).catch(() => {
            this.setState({
                sales_manager_users: []
            });
        });
        CompanyService.getISPList().then(({ data }) => {
            this.setState({
                inside_sales_persons: data
            });
        }).catch(() => {
            this.setState({
                inside_sales_persons: []
            });
        });
        this.props.caseId && CompanyService.getCaseMovementBtns(this.props.caseId).then(({ data }) => {
            this.setState({
                showCaseMovementBtns: data
            });
        }).catch((err) => {
            console.log("inside btns data catch", err);
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.caseId &&
            this.props.stageId &&
            (prevProps.caseId !== this.props.caseId ||
                prevProps.stageId !== this.props.stageId)
        ) {
            this.props.fetchPortfolioView(this.props.caseId, this.props.stageId);
        }
        if (this.props.deleteAssociateStatus == STATE_STATUS.FETCHED) {
            this.props.fetchCaseAssociates(this.props.caseId);
            this.props.updateCaseAssociateStatus(this.props.caseId, STATE_STATUS.UNFETCHED);
        }
        if (
            this.props.caseId &&
            this.props.action === CASE_VIEW_ACTION &&
            (this.props.caseAssociatesStatus === STATE_STATUS.UNFETCHED || !this.props.status)
        ) {
            this.props.fetchCaseAssociates(this.props.caseId);
        }
        if (
            this.props.caseId &&
            this.props.action === CASE_VIEW_ACTION &&
            (this.props.caseBankAccountsStatus === STATE_STATUS.UNFETCHED || !this.props.status)
        ) {
            this.props.fetchCaseBankAccounts(this.props.caseId);
        }
        if (this.props.caseDetailFieldsStatus === STATE_STATUS.UNFETCHED) {
            this.props.fetchCaseDetailFields(this.props.caseId);
        }
        if (
            this.props.status === STATE_STATUS.FETCHED &&
            this.props.companyStatus &&
            this.props.companyStatus.get("companyStatus") ===
            STATE_STATUS.FETCHED &&
            !this.state.visible
        ) {
            this.setState({
                visible: true
            });
        }
        if (
            this.props.companyId &&
            this.props.action === CASE_VIEW_ACTION &&
            (!this.props.companyStatus ||
                this.props.companyStatus.get("companyStatus") ===
                STATE_STATUS.UNFETCHED)
        ) {
            this.props.fetchCompanyProfile(this.props.companyId, this.props.caseId);
        }
        if (
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.disableActionButton === false &&
            this.state.disableActionButton
        ) {
            this.setState({
                disableActionButton: false
            });
        }
        if (
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.updated &&
            !this.state.case_task_updated
        ) {
            this.setState({
                case_task_updated: true
            }, () => {
                this.forceUpdate();
            });
        }
        // if (this.props.isParentCaseExist && !this.state.fetchedCasesList) {
        //     this.handleFetchPreviousCasesList();
        // }
        if (this.props.company && this.props.caseDetail && !this.state.fetchingLedgerMaster) {
            this.fetchLedgerMasters();
        }
        if (this.props.caseDetail && prevProps.status !== this.props.status && this.props.status === "FETCHED") {
            this.props.caseId && CompanyService.getCaseMovementBtns(this.props.caseId).then(({ data }) => {
                this.setState({
                    showCaseMovementBtns: data
                });
            }).catch((err) => {
                console.log("inside btns data catch", err);
            });
        }
        if (this.state.fetchingLedgerMaster && prevProps.status !== this.props.status && this.props.status === "FETCHED") {
            this.fetchLedgerMasters();
        }
    }

    fetchLedgerMasters = () => {
        this.setState({
            fetchingLedgerMaster: true
        }, async () => {
            const { company, caseDetail } = this.props;
            const { data: ledger_masters } = await fetchCaseLedgerMasters(caseDetail.id);
            const { data: gstin_ledger_masters } = await UnderwritingService.getSupplyChainListByGSTIN(company.gstin);
            gstin_ledger_masters.map(_ => {
                if (!ledger_masters.find(__ => __.ledger_analysis && __.ledger_analysis.id === _.id || _.id === __.id)) {
                    ledger_masters.push({ ..._, checked: false });
                }
            });
            const ledger_master_distinct_sellers = [...new Set(ledger_masters.map(_ => _.seller && Number(_.seller.id)))].sort();
            const case_distinct_sellers = [...new Set(caseDetail.sellers && caseDetail.sellers.map(_ => Number(_.id)))].sort();
            let are_sellers_same = true;
            if (ledger_master_distinct_sellers.length === case_distinct_sellers.length) {
                ledger_master_distinct_sellers.map((_, k) => {
                    if (_ !== case_distinct_sellers[k]) {
                        are_sellers_same = false;
                    }
                });
            } else {
                are_sellers_same = false;
            }
            if (this.props.stageId == 56) {
                are_sellers_same = true;
            }
            this.setState({
                are_sellers_same
            });
        });

    }

    handleGuarantorNotification() {
        if (
            !this.notificationShowed &&
            this.props.companyId &&
            this.props.action === CASE_VIEW_ACTION &&
            (this.props.companyStatus &&
                this.props.companyStatus.get("companyStatus") ===
                STATE_STATUS.FETCHED)
        ) {
            if (this.props.company.isGuarrantorRequired && ![9, 14].includes(+this.props.stageId)) {
                this.notificationShowed = true;
                notification.warn({
                    message: "Guarantor Required",
                    description:
                        "One of the associates have the age > 65 or age <25"
                });
            }
        }
    }

    onDrawerClose = () => {
        this.setState(
            {
                visible: false
            },
            () => {
                this.props.history.goBack();
            }
        );
    };
    toggleExpand = () => {
        this.setState({
            expanded: !this.state.expanded
        });
    };
    handleGroupInfoUpdated = () => {
        this.setState((prev) => ({
            groupInfoRefreshKey: prev.groupInfoRefreshKey + 1,
        }));
    };
    viewCaseNotes = () => {
        this.props.history.push(this.props.location.pathname, {
            ...this.props.location.state,
            case_notes: {
                caseId: this.props.caseId,
                stageId: this.props.stageId,
                case_notes_view: true
            }
        });
    };
    openCaseMetaDrawer = () => {
        const { location: { pathname, state: locationState }, caseId } = this.props;
        this.props.history.push(pathname, {
            ...locationState,
            case_meta: {
                caseId
            }
        });
    }

    handleMenuClick = (val) => {
        const modal = Modal.confirm();
        modal.update({
            title: "Are you sure?",
            content: "This will go to the Sales Cordinator.",
            onOk: () => this.props.updateCaseType(this.props.caseId, val.key),
            onCancel: () => { },
            okText: "Yes",
            cancelText: "No"
        });
    }

    menu = (
        <Menu onClick={this.handleMenuClick}>
            <Menu.Item key="2">
                Enhance
            </Menu.Item>
            <Menu.Item key="3">
                Renew
            </Menu.Item>
            <Menu.Item key="4">
                Amendment
            </Menu.Item>
        </Menu>
    );

    getMenu = (menuArr) => (
        <Menu>
            {menuArr.map(_ => {
                if (_.children) {
                    return (
                        <Menu.SubMenu
                            key={_.key}
                            title={_.label}
                        >
                            {_.children}
                        </Menu.SubMenu>
                    );
                }
                return (
                    <Menu.Item
                        key={_.key}
                        size={"small"}
                        className={_.className}
                        onClick={_.onClick}
                        htmlType={_.htmlType || "button"}
                        disabled={_.disabled}>
                        {_.label}
                    </Menu.Item>
                );
            }
            )}
        </Menu>
    );

    checkIfSalesCoordinator() {
        const loggedInUser = this.props.user.getIn(["data", "id"]);
        if (
            this.props.userGroups &&
            this.props.userGroups.includes(3)
        ) {
            return true;
        }
        if (
            loggedInUser &&
            this.props.currentCaseTask &&
            this.props.currentCaseTask.this_user &&
            this.props.currentCaseTask.this_user.id &&
            Number(loggedInUser) == Number(this.props.currentCaseTask.this_user.id)
        ) {
            return true;
        }
        return false;
    }

    casePullBack = () => {
        if (this.state.remarksValue) {
            let remarkData = { "pull_back_remarks": this.state.remarksValue, "action_reason": this.state.pullBackActionReason };
            this.setState({
                pullbackloader: true
            });
            CompanyService.postPullBack(this.props.caseId, remarkData).then(() => {
                message.success("Case Moved Successfully to Credit Appraisal!");
                this.setState({
                    remarksValue: "",
                    showError: false,
                    showPullBackRemark: false,
                    pullbackloader: false
                }, () => window.location.reload());
            }).catch((err) => {
                message.error(err?.message?.[0]);
                this.setState({ pullbackloader: false });
            });
        } else {
            this.setState({
                showError: true,
            });
        }
    }

    getActionModalUnassign = () => {
        this.setState({ openChecklistModalUnAssign: true });
    }

    closeModalUnAssign = () => {
        this.setState({
            openChecklistModalUnAssign: false
        });
    }

    onUnAssigningCase = () => {
        let finalData = { "remarks": this.state.onChangeReasonUnAssign, "action_reason": this.state.onChangeReasonUnAssign };
        try {
            this.state.onChangeReasonUnAssign ? CaseService.UnAssignCase(this.props.case_task_id, finalData).then(res => {
                res.status === 200 && message.success("Case has been Un-Assigned"), this.setState({ openChecklistModalUnAssign: false }),
                    this.props.history.goBack();
            }).catch((error) => {
                if (error && error.status == 404) {
                    message.error(error.data.detail);
                }
                if (error && error.non_field_errors && error.non_field_errors.length) {
                    error.non_field_errors.map(_ => {
                        message.error(_);
                    });
                }
                this.setState({ openChecklistModalUnAssign: false });
            }) : message.error("Please enter remarks.");
        } catch (err) {
            message.error("Something went wrong!");
        }
    }

    getUnassignModal = () => {
        return (
            <Modal
                visible={this.state.openChecklistModalUnAssign}
                closable={true}
                title={"Un-Assign"}
                onOk={this.onUnAssigningCase}
                destroyOnClose
                width={600}
                onCancel={this.closeModalUnAssign}
            >
                {this.renderRemarksBox()}
            </Modal>
        );
    }

    renderRemarksBox = () => {
        return (
            <Input.TextArea
                rows={2}
                placeholder={"Remarks"}
                onChange={(e) => this.setState({ onChangeReasonUnAssign: e.target.value })}
            />
        );
    }

    pullBackBtnFn = () => {
        CaseService.getCategoryWiseReasons(this.props.stageId, 5).then(({ data }) => {
            this.setState({
                actionReasonsList: data
            }, () => this.forceUpdate());
        });
        this.setState({ showPullBackRemark: true });
    }

    openDeferralModal = () => {
        const { deferral_json = [] } = this.props.caseDetail || {};

        const categoryIdMap = {};
        const openCategories = []; 
        const closedCategories = [];
        deferral_json.forEach(d => {
            d.category.forEach(cat => {
                categoryIdMap[cat] = d.id;
                if (d.action === true) {
                    openCategories.push(cat);
                } else {
                    closedCategories.push(cat);
                }
            });
        });
        const selectedCategories =  Object.keys(categoryIdMap).map(Number);
        const isClosureStage = [13, 17].includes(this.props.stageId);
        this.setState({
            deferralModal: true,
            actionDeferral: isClosureStage
                ? "No"
                : selectedCategories.length > 0
                    ? "Yes"
                    : null,
            categoryDeferral: isClosureStage ? [] : selectedCategories,
            selectedCategories,
            deferralCategoryIdMap: categoryIdMap,
            openCategories,
            closedCategories
        });
    };

    shouldShowCategory = (value) => {
        const { actionDeferral, openCategories } = this.state;
    
        if (!actionDeferral) return true;
        if (actionDeferral === "Yes") {
            return !openCategories.includes(value);
        }
        if (actionDeferral === "No") {
            return openCategories.includes(value);
        }
        return true;
    };

    getClosableCategories = () => {
        const { openCategories } = this.state;
    
        return [...DEFERRAL_CATEGORY].filter(([_, value]) =>
            openCategories?.includes(value)
        );
    };
    
    caseActions = () => {
        let buttonFinalArr = [];
        const caseDetail = this.props.caseDetail;
        const schemeType =
            caseDetail != null && typeof caseDetail.get === "function"
                ? caseDetail.get("scheme_type")
                : caseDetail != null
                    ? caseDetail.scheme_type
                    : undefined;
        const isParentFactoringCase =
            caseDetail != null && typeof caseDetail.get === "function"
                ? caseDetail.get("is_parent_factoring_case")
                : caseDetail != null
                    ? caseDetail.is_parent_factoring_case
                    : undefined;
        const isCepScheme = schemeType === "Factoring";
        const getCaseField = key =>
            caseDetail != null && typeof caseDetail.get === "function"
                ? caseDetail.get(key)
                : caseDetail != null
                    ? caseDetail[key]
                    : undefined;
        const isAnchorRecommendationPending =
            Number(this.props.stageId) === 10 &&
            getCaseField("is_anchor_recommendation_required") === true &&
            getCaseField("is_anchor_recommended") !== true &&
            getCaseField("is_anchor_rejected") !== true;
        // let isUserAssigned = false;
        // const isStageAdmin = !!(this.props.stagePermissions.get("data") || []).find(_ => (this.props.stageAdminIds && this.props.stageAdminIds.includes(_.id) && _.id === this.props.stageId && !_.key));
        const isCreditAppraisal = !!(this.props.stagePermissions.get("data") || []).find(_ => (this.props.stageAdminIds && this.props.stageAdminIds.includes(_.id) && _.id === 7 && !_.key));
        // const checkCurrentStage = !!(this.props.stagePermissions.get("data") || []).find(_ => (_.id === this.props.stageId && !_.key));
        // if (this.props.assignedUsers && this.props.user) {
        //     isUserAssigned = !!(this.props.assignedUsers &&
        //         this.props.assignedUsers
        //             .find(_ =>
        //                 _.this_user && _.this_user.id === this.props.user.getIn(["data", "id"])
        //             ));
        // }
        if (
            // this.state.showCaseMovementBtns?.is_pull_back_to_credit_appraisal_button_visible
            this.state.showCaseMovementBtns?.is_pull_back_to_credit_appraisal_button_visible
        ) {
            buttonFinalArr.push(
                <Button
                    key={"pullBack"}
                    style={{ marginLeft: "10px" }}
                    type={"primary"}
                    onClick={this.pullBackBtnFn}
                >
                    Pull-back to Credit Appraisal
                </Button>
            );
        }
        if (
            // this.props.case_task_id &&
            // this.props.isCaseRejectedOrHold &&
            // // checkCurrentStage &&
            // this.checkIfSalesCoordinator()
            this.state.showCaseMovementBtns?.is_open_button_visible
        ) {
            buttonFinalArr.push(
                <Button
                    key={"assign"}
                    type={"primary"}
                    onClick={this.getActionModal.bind(null, "OPEN")}
                >
                    Open
                </Button>
            );
        }

        // const hasUser = this.props.currentCaseTask && this.props.currentCaseTask.this_user && this.props.currentCaseTask.this_user.id;

        if (
            // (!this.props.isCaseUnAssigned || hasUser) && !isUserAssigned && isStageAdmin && !this.props.isCaseRejectedOrHold
            this.state.showCaseMovementBtns?.is_reassign_button_visible
        ) {
            buttonFinalArr.push(
                <Button
                    key={"assign"}
                    type={"primary"}
                    onClick={this.getActionModal.bind(null, "REASSIGN")}
                >
                    Reassign
                </Button>
            );
        }

        if (
            (!isCepScheme || isParentFactoringCase) &&
            // this.props.isCaseUnAssigned && !isUserAssigned && !this.props.isCaseRejectedOrHold && checkCurrentStage
            this.state.showCaseMovementBtns?.is_assign_button_visible
        ) {
            buttonFinalArr.push(
                <Button
                    key={"assign"}
                    type={"primary"}
                    disabled={isAnchorRecommendationPending}
                    onClick={this.getActionModal.bind(null,
                        // this.props.stageId == 2 ? "PROCEED" :
                        "ASSIGN")}
                >
                    {
                        // this.props.stageId == 2 ? "Approve" :
                        "Assign"}
                </Button>
            );
            if (isAnchorRecommendationPending) {
                buttonFinalArr.push(
                    <Tag key={"anchor-recommendation-required"} color={"orange"}>
                        Anchor recommendation is required
                    </Tag>
                );
            }
        }
        // if (
        // // this.props.isCaseUnAssigned && !isUserAssigned && !this.props.isCaseRejectedOrHold && checkCurrentStage
        // this.state.showCaseMovementBtns?.is_unassign_button_visible
        // ) {
        //     buttonFinalArr.push(
        //         <Button
        //             key={"unassign"}
        //             type={"primary"}
        //             onClick={this.getActionModal.bind(null, 
        //                 "UNASSIGN")}
        //         >
        //             {
        //                 "Un-Assign"}
        //         </Button>
        //     );
        // }
        if (
            this.state.showCaseMovementBtns?.is_unassign_button_visible
        ) {
            const items = (
                <Button
                    key={"usassign"}
                    type={"primary"}
                    onClick={this.getActionModalUnassign}
                >
                    Un-Assign
                </Button>
            );
            buttonFinalArr.unshift(items);
        }
        if (!isCepScheme && [11, 13, 14, 17, 24, 35, 56, 57].includes(this.props.stageId)) {
            buttonFinalArr.unshift(
                <Button
                    type={"primary"}
                    disabled={this.state.isDeferralUpdating}
                    // disabled={this.props.caseDetail?.deferral_tagged === false}
                    // onClick={() => this.setState({ deferralModal: !this.state.deferralModal })}>
                    onClick={() => this.openDeferralModal()}>
                    {this.props.caseDetail?.deferral_tagged ?
                        "Deferral Open" : this.props.caseDetail?.deferral_tagged == false ?
                            "Deferral Closed" : "Deferral"}
                </Button>
            );
        }

        const ProceedButton = ProceedChecklist()(
            String(this.props.stageId),
            this.props.caseId,
            this.props.companyId,
            this.state.are_sellers_same,
            this.props.caseDetail
        );

        // if (
        //     this.props.location.pathname.includes("inbox") &&
        //     this.props.stagePermissions &&
        //     checkCurrentStage &&
        //     this.props.stageName &&
        //     this.props.isUserAllowedToEdit &&
        //     this.props.currentCaseTask &&
        //     this.props.currentCaseTask.this_stage &&
        //     this.props.currentCaseTask.this_stage !== 2
        // ) {
        const permissionMap = this.props.stagePermissions.getActionPermissionMap(
            this.props.stageName
        );
        let menuArr = [];
        // const menu = this.getMenu(menuArr);
        if (this.state.showCaseMovementBtns?.is_refer_button_visible)
            menuArr.push(
                {
                    key: "refer",
                    type: "default",
                    onClick: this.getActionModal.bind(null, "REFER"),
                    // disabled: !permissionMap.get("REFER") ||
                    //         this.state.disableActionButton,
                    label: "Refer"
                });

        let btnArray = [];
        // this.props.stageId !== 24 &&
        let btnArrayProceed = this.props.stageId !== 24 ? [
            <ProceedButton
                key={"proceed"}
                type={"primary"}
                onClick={this.getActionModal.bind(null, "PROCEED")}
            // disabled={
            //     !permissionMap.get("PROCEED") ||
            //     this.state.disableActionButton
            // }
            >
                Proceed
            </ProceedButton>
        ] : [
            <Button
                key={"assign"}
                type={"primary"}
                onClick={this.getActionModal.bind(null, "PROCEED")}
            >
                Proceed
            </Button>
        ];
        // Number.isInteger: without a resolved stage the checklist can't be looked
        // up, and the HOC would fall through and proceed with NO checks. Better to
        // not offer the button at all than to offer an unvalidated one.
        if (this.state.showCaseMovementBtns?.is_proceed_button_visible && Number.isInteger(this.props.stageId) && ![4, 5, 18].includes(this.props.stageId)) {
            btnArray.push(
                btnArrayProceed
            );
        }
        // : [
        //     <Button
        //         key={"assign"}
        //         type={"primary"}
        //         onClick={this.getActionModal.bind(null, "PROCEED")}
        //     >
        //         Proceed
        //     </Button>
        // ];
        if (!this.props.isCaseRejectedOrHold) {
            menuArr.unshift(
                {
                    key: "hold",
                    type: "default",
                    onClick: this.getActionModal.bind(null, "HOLD"),
                    disabled: !this.state.showCaseMovementBtns?.is_hold_button_visible,
                    label: "Hold"
                },
                {
                    key: "reject",
                    type: "default",
                    onClick: this.getActionModal.bind(null, "REJECT"),
                    disabled: !this.state.showCaseMovementBtns?.is_reject_button_visible,
                    label: "Reject"
                }
            );
        }
        //     if (
        //     // isStageAdmin
        //     ) {
        //         menuArr.unshift(
        //             {
        //                 key: "reassign",
        //                 type: "default",
        //                 onClick: this.getActionModal.bind(null, "REASSIGN"),
        //                 disabled: this.state.disableActionButton,
        //                 label: "Reassign"
        //             }
        //         );
        //     }
        if (this.state.showCaseMovementBtns?.is_pullback_to_progcap_ps_kit_for_tl) {
            menuArr.unshift(
                {
                    key: "pull_back_to_ps_kit",
                    type: "default",
                    onClick: this.getActionModal.bind(null, "PULL_BACK_TO_PS_KIT"),
                    // disabled: !this.state.showCaseMovementBtns?.is_hold_button_visible,
                    label: "Pull Back To Ps-Kit"
                },)
        }
        const menu = this.getMenu(menuArr);

        const items = (
            <Dropdown.Button
                key={"case-notes"}
                type={"default"}
                onClick={this.viewCaseNotes}
                overlay={menu}
            >
                Case Comments
            </Dropdown.Button>
        );

        btnArray.unshift(items);

        if (
            !isCepScheme &&
            // this.props.user && this.props.user.getIn(["permissions", "case_meta_data_update"])
            this.state.showCaseMovementBtns?.is_update_case_detail_button_visible
        ) {
            btnArray.unshift(
                <Dropdown.Button
                    key={"case-meta"}
                    type={"default"}
                    onClick={this.openCaseMetaDrawer}
                    overlay={this.menu}
                >
                    Update Case Details
                </Dropdown.Button>
            );
        }
        buttonFinalArr.push(btnArray);
        // } 
        // else {
        // buttonFinalArr.push(
        //     <Button
        //         key={"case-notes"}
        //         type={"default"}
        //         onClick={this.viewCaseNotes}
        //     >
        //             Case Comments
        //     </Button>

        // );
        // }
        return buttonFinalArr;
    };

    getCompanyId = (name, companyId) => {
        var result = name && name.toLowerCase().replace(/\w+/g, _capitalize);
        return (
            <React.Fragment>
                <Tooltip title={`${result} (${companyId})`}>
                    <span className={"company"}>
                        {result}
                    </span>
                </Tooltip>
                <span style={{
                    color: "#f9f9f9"
                }}>{` (${companyId})`}</span>
            </React.Fragment>
        );
    }

    handleFetchPreviousCasesList = async () => {
        const gstin = this.props.company && this.props.company.get("gstin");
        if (this.props.isParentCaseExist && !this.state.fetchedCasesList && gstin) {
            this.setState({
                fetchedCasesList: true
            });
            await CaseService.caseSearchList(gstin).then(({ data }) => {
                this.setState({
                    fetchedCasesList: true,
                    casesList: new List(data.results.filter(_ => _.id !== this.props.caseId))
                });
                this.props.GstinsearchList(this.props.caseId, STATE_STATUS.FETCHED);
            }).catch(() => {
                this.props.GstinsearchList(this.props.caseId, STATE_STATUS.FETCHING);
                this.setState({
                    fetchedCasesList: true
                });
            });
        } else if (!this.props.isParentCaseExist && !this.state.fetchedCasesList) {
            this.setState({
                casesList: new List([]),
                fetchedCasesList: true
            });
        }
    }

    toggleSupplyChainRemark = () => {
        message.info(`${this.props.caseDetail && this.props.caseDetail.supplychain_remarks ? this.props.caseDetail.supplychain_remarks : "No Remarks"}`, 3);
    }

    callAsmList = () => {
        // CaseService.getCaseDetail(this.props.caseId).then(({ data }) => {
        //     this.setState({
        //         asm_data: data.sales_manager_user
        //     });
        // }).catch((err) => {
        //     console.log("err", err);
        // });
    }

    callISPList = () => {
        // CaseService.getCaseDetail(this.props.caseId).then(({ data }) => {
        //     this.setState({
        //         isp_data: data.inside_sales_personnel
        //     });
        // }).catch((err) => {
        //     console.log("err", err);
        // });
    }

    changePullBackRemarks = (e) => {
        let remarksValue = e.target.value;
        this.setState({
            remarksValue: remarksValue,
            showError: false
        });
    }

    handleClose = () => {
        this.setState({
            remarksValue: "",
            showError: false,
            showPullBackRemark: false
        });
    }

    handleCloseDeferral = () => {
        this.setState({
            deferralModal: false
        });
    }

    onChangeAction = (action) => {
        this.setState({ actionDeferral: action, categoryDeferral: []})
    }
    onScrollFn = (e) => {
        const scrollingPos = e.target?.scrollTop;
        sessionStorage.setItem("scrollPositionDocReview", scrollingPos);
    }

    updateDocList = (caseId, companyId) => {
        this.props.fetchCompanyDocuments(caseId, companyId)
    }

    onDeferral = () => {
        if (this.state.isDeferralUpdating) {
            return;
        }
        let body;
        if (this.state.actionDeferral === "No") {
            const deferralId = this.state.deferralCategoryIdMap[this.state.categoryDeferral];
            body = this.props.caseDetail?.deferral_tagged === null ?
                { "action": "False" } :
                {
                    "action": "False",
                    "id": deferralId,
                    "category": Array.isArray(this.state.categoryDeferral) ? this.state.categoryDeferral : [this.state.categoryDeferral],
                    "untag_remarks": this.state.remarksDeferral.trim()
                };
        } else {
            // Ensure categoryDeferral is always an array
            const categoryArray = Array.isArray(this.state.categoryDeferral) 
                ? this.state.categoryDeferral 
                : (this.state.categoryDeferral !== null && this.state.categoryDeferral !== undefined)
                    ? [this.state.categoryDeferral]
                    : [];
            
            body = {
                "action": "True",
                "category": categoryArray,
                // "end_date": this.state.deferralEndDate?._isAMomentObject ? this.state.deferralEndDate.format('YYYY-MM-DD') : null,
                "tag_remarks": this.state.remarksDeferral.trim()
            };
        }
        const validateBody = (body) => {
            for (let key in body) {
                if (body[key] === null || body[key] === "undefined" || body[key] === "" || (Array.isArray(body[key]) && body[key].length === 0)) {
                    return false;
                }
            }
            return true;
        };
        if (validateBody(body)) {
            this.setState({ isDeferralUpdating: true });
            CaseService.deferralTag(this.props.caseId, this.state.actionDeferral, body).then(res => {
                if (res.status === 200 && this.state.actionDeferral === "No" && res?.data?.untag_remarks) {
                    message.success("Deferral Closed");
                }
                if (res.status === 200 && this.state.actionDeferral === "No" && !res?.data?.untag_remarks) {
                    message.success(res?.data?.message || "Deferral Not Opted");
                }
                if (res.status === 200 && this.state.actionDeferral === "Yes") {
                    message.success("Deferral Created");
                }
                this.props.fetchCaseDetail(this.props.caseId);
            }).catch(err => {
                console.log("inside catch", err);
            }).finally(() => {
                this.setState({
                    deferralModal: false,
                    isDeferralUpdating: false
                })
            })
        } else {
            message.error("Please fill all required fields before submitting.");
        }
    }

    // handleDateInput = (val) => {
    //     this.setState({deferralEndDate: val})
    // }

    onSelectReasonCategory = val => {
        let reasonCategory = this.state.actionReasonsList && this.state.actionReasonsList.find(_ => _.id == val);
        if (reasonCategory) {
            this.setState({
                pullBackActionReason: reasonCategory.name,
            });
        }
    }

    render() {
        const {
            name,
            caseDetail,
            caseSanction,
            companyId,
            company,
            caseId,
            tab,
            history,
            location,
            match
        } = this.props;
        const systemRecommendation = caseDetail && caseDetail.recommendation_status;
        let system_recommendation_bg = "#6fac95";
        if (systemRecommendation === "Rejected") {
            system_recommendation_bg = "#FFA79C";
        }
        if (systemRecommendation === "In Review") {
            system_recommendation_bg = "#F9E9D2";
        }
        const anchors = caseDetail?.toJS()?.supply_chains && caseDetail?.toJS()?.supply_chains.map(el => el.anchor.id);
        const recreditViewOnlyPermission = this.props.caseDetail?.toJS().current_case_task?.some(el => el.this_stage === 42);
        const postSanctionPermission = this.props.userGroups.includes(10);
        const today = moment();

        const endDate = moment().add(30, 'days');
        function disabledDateFn(current) {
            return current && (current < today ||
                current > endDate);
        }
        return (
            <React.Fragment>
                {this.getUnassignModal()}
                <Modal
                    visible={this.state.showPullBackRemark}
                    title={"Pull-back Remarks"}
                    onCancel={this.handleClose}
                    footer={[
                        <Button key="submit" onClick={this.handleClose} >
                            Cancel
                        </Button>,
                        <Button loading={this.state.pullbackloader} key="back" type={"primary"} onClick={() => this.casePullBack()}>
                            Submit
                        </Button>,
                    ]}
                >
                    <Select
                        style={{ width: "100%", marginBottom: "10px" }}
                        placeholder="Select a reason category"
                        onChange={this.onSelectReasonCategory}
                        value={this.state.pullBackActionReason}
                    >
                        {this.state.actionReasonsList &&
                            this.state.actionReasonsList.map(reason => (
                                <Option key={reason.id} value={reason.id}>
                                    {reason.name}
                                </Option>
                            ))}
                    </Select>
                    <TextArea
                        required={true}
                        onChange={this.changePullBackRemarks}
                        rows={4}
                        placeholder={"Please enter the reason to Pull Back."}
                    />
                    {
                        this.state.showError ? <span style={{ color: "red", marginTop: "5px" }}>This field is required!</span> : null
                    }
                </Modal>
                <Modal
                    destroyOnClose={true}
                    title={"Deferral"}
                    okText={"Submit"}
                    onOk={() => this.onDeferral()}
                    confirmLoading={this.state.isDeferralUpdating}
                    // okButtonProps={{
                    //     disabled:
                    //       [13, 17].includes(this.props.stageId) &&
                    //       this.state.actionDeferral === "Yes",
                    //   }}
                    width={400}
                    visible={this.state.deferralModal}
                    onCancel={this.handleCloseDeferral}
                >
                    <Select
                        className="w-100 mb-10"
                        placeholder="Select Action"
                        value={this.state.actionDeferral}
                        // disabled={[13, 17].includes(this.props.stageId)}
                        onChange={this.onChangeAction}
                    >
                        <Option value={"Yes"} key={1} disabled={[13, 17].includes(this.props.stageId)}>Opt-in</Option>
                        <Option value={"No"} key={2}>Opt-out</Option>
                    </Select>
                    {/* <Select
                        mode={![13, 17].includes(this.props.stageId) ? "multiple" : undefined}
                        className="w-100 mb-10"
                        placeholder="Select Category"
                        // disabled={caseDetail?.deferral_tagged || this.state.actionDeferral == "No"}
                        disabled={this.state.actionDeferral == "No"}
                        value={this.state.categoryDeferral}
                        onChange={(item) => this.setState({ categoryDeferral: item })}
                    > */}
                    {/* {this.props.stageId === 57
                            ? <Option value={DEFERRAL_CATEGORY.get("No NACH PDC")} key={"No NACH PDC"}>
                                No NACH PDC
                            </Option>
                            : (
                                [...DEFERRAL_CATEGORY]
                                    .filter(([label]) =>
                                        this.props.stageId === 56
                                            ? label !== "No NACH PDC"
                                            : !["Physical OSV Pending", "No NACH PDC"].includes(label)
                                    )
                                    .map(([label, value]) => (
                                        <Option value={value} key={label}>{label}</Option>
                                    ))
                            )} */}
                    {![13, 17].includes(this.props.stageId) ? (
                        <Select
                            mode={this.state.actionDeferral==="Yes" ? "multiple" : undefined}
                            className="w-100 mb-10"
                            placeholder="Select Category"
                            // disabled={this.state.actionDeferral === "No"}
                            // value={this.state.categoryDeferral}
                            onChange={(items) =>
                                this.setState({ categoryDeferral: items })
                            }
                        >
                            {[...DEFERRAL_CATEGORY].filter(([_, value]) => this.shouldShowCategory(value))
                                .map(([label, value]) => {
                                const isAlreadySelected =
                                    this.state.selectedCategories.includes(value);
                                return (
                                    <Option
                                        key={value}
                                        value={value}
                                        // disabled={this.isDisabledCategory(value)}
                                    >
                                        {label}
                                    </Option>
                                );
                            })}
                        </Select>
                    ) : (
                        <Select
                            className="w-100 mb-10"
                            placeholder="Select Category to Close"
                            // value={this.state.categoryDeferral[0]}
                            onChange={(item) =>
                                this.setState({ categoryDeferral: item })
                            }
                        >
                            {this.getClosableCategories().map(([label, value]) => {
                                // const isAlreadyClosed =
                                // this.state.categoryIdMapInactive.includes(value);
                                // const label = [...DEFERRAL_CATEGORY].find(
                                //     ([_, v]) => v === value
                                // )?.[0];

                                return (
                                    <Option key={value} value={value}>
                                        {label}
                                    </Option>
                                );
                            })}
                        </Select>
                    )}
                    {/* {this.props.caseDetail?.deferral_json?.end_date && <DatePicker  
                        style={{
                            width: "100%"
                        }}
                        disabledDate={disabledDateFn}
                        disabled={true}
                        size={"large"}
                        className={"mb-5"}
                        // onChange={this.handleDateInput}
                        value={this.state.deferralEndDate}
                        placeholder={"Date"}
                    />} */}
                    <TextArea
                        onChange={(e) => this.setState({ remarksDeferral: e.target.value })}
                        rows={4}
                        // value={this.state.remarksDeferral}
                        placeholder={"Remarks"}
                    />
                </Modal>
                <Drawer
                    visible={this.state.visible}
                    closable={false}
                    destroyOnClose={false}
                    mask={true}
                    maskClosable={true}
                    placement={"right"}
                    onClose={this.onDrawerClose}
                    height={"100vh"}
                    width={"100%"}
                    className={"case-details-drawer scrollable-drawer"}
                >
                    <Layout style={{ height: "inherit" }}>
                        <LoaderSkeleton loading={this.isLoading()}>
                            <Row className={"h-100 case-detail-row case-detail-row-scroll"} onScroll={this.onScrollFn}>
                                <Col span={24} className={"case-detail-page-header"}>
                                    <PageHeader
                                        className={"drawerExtraButtons company-name"}
                                        title={this.getCompanyId(name, companyId)}
                                        onBack={this.onDrawerClose}
                                        //     tags={!this.props.userGroups.includes(9) ? [
                                        //         <Tag key={"constitution"} color={"#246079"}>
                                        //             {company &&
                                        //                 CONSTITUTION_TYPES.findKey(_ => _ === company.constitution)}
                                        //         </Tag>,
                                        //         <Tag key={"priority"} color={"#438098"}>
                                        //             {/* <Icon
                                        //                 type={"flag"}
                                        //                 theme="filled"
                                        //                 style={{
                                        //                     marginRight: "10px"
                                        //                 }}
                                        //             /> */}
                                        //             {caseDetail &&
                                        //                 caseDetail.login_type}
                                        //         </Tag>,
                                        //         <Tag key={"system_recommendation"} color={system_recommendation_bg}>
                                        //             {caseDetail &&
                                        //                 caseDetail.recommendation_status}
                                        //         </Tag>,
                                        //         <Tag key={"ledger-status"} color="cyan">{this.state.caseLedgerStatus}</Tag>,
                                        //         <Tag key={"esign_status"} color={"#25a841"}>
                                        //             {caseDetail && caseDetail.esign_status}
                                        //         </Tag>,
                                        //         <Tag key={"existing_case"} color={"#425af5"}>
                                        //             <Tooltip title={"Existing Case Details"}>
                                        //                 {(caseDetail && caseDetail.existing_case) || "No Existing Case"}
                                        //             </Tooltip>
                                        //         </Tag>,
                                        //         <Tag key={"industry"} color={"#ffa500"}>
                                        //             <Tooltip title={"Industry"}>
                                        //                 {(caseDetail && caseDetail.industry)}
                                        //             </Tooltip>
                                        //         </Tag>,
                                        //         caseDetail && caseDetail.get("is_green_channel" , false) && <Tag color="rgb(105 202 8)">Green Channel Case</Tag>,
                                        //         <Tag key={"industry"} color={"#FF0000"}>
                                        //         <Tooltip title={"Product Type"}>
                                        //             {(caseDetail && caseDetail.business_product_type == 2 ? "Vendor Finance" : "")}
                                        //         </Tooltip>
                                        //     </Tag>,
                                        //     <Tag key={"is_balance_transfer_case"} color={"rgb(202 79 79)"}>
                                        //      <Tooltip title={"Balance Transfer"}>
                                        //         {(caseDetail && caseDetail.is_balance_transfer_case ? "Balance Transfer" : null)}
                                        //     </Tooltip>
                                        // </Tag>,
                                        //         <Tag key={"is_refered_back"} color={"#425a35"}>
                                        //             <Tooltip title={"Refer back case"}>
                                        //                 {(caseDetail && caseDetail.is_refered_back)}
                                        //             </Tooltip>
                                        //         </Tag>,
                                        //         caseDetail && caseDetail.get('is_self_served_journey') && <Tag className="tooltip-size-custom" color={"#425a35"}>
                                        //         <Tooltip title={  <>
                                        //             1. Limit should be between Rs.2L and Rs.10L.<br />
                                        //             2. All documents should be upfront verified.<br />
                                        //             3. Applicant should have good CIBIL.<br />
                                        //             4. Constitution should be proprietorship with no guarantor.<br />
                                        //         </>}>
                                        //             Quick Onboarding
                                        //         </Tooltip>
                                        //     </Tag>,
                                        //         caseDetail && caseDetail.is_bundled && <Tag key={"is_bundled"} color={"#ff0000"}>
                                        //             <Tooltip title={"Bundled"}>
                                        //                 {"Bundled"}
                                        //             </Tooltip>
                                        //         </Tag>,
                                        //         caseDetail && caseDetail.pre_approval_leads && <Tag key={"pre_approved_leads"} color={"#9f9b0c"}>
                                        //             <Tooltip title={"Pre-Approved Lead"}>
                                        //                 {"Pre-Approved Lead"}
                                        //             </Tooltip>
                                        //         </Tag>,

                                        //         caseDetail && caseDetail.seasonal_pre_approved_tl && <Tag key={"seasonal_pre_approved_tl"} color={"#902ec9ff"}>
                                        //             Season Pre Approved TL 25
                                        //         </Tag>,
                                        //         caseDetail && caseDetail.get("is_d2r_case" , false) && <Tag color="blue">D2R</Tag>,
                                        //         <Icon key={"supplychain_remarks"} style={{
                                        //             fontSize: "14px"
                                        //         }} type={"info-circle"} onClick={this.toggleSupplyChainRemark} />,
                                        //         <span key="deviation_allowed" style={{color:"#D84D21", fontWeight:"bold"}} className="ml-20">
                                        //             {(anchors?.includes(27185) || anchors?.includes(5486)) && (caseDetail && caseDetail.is_deviation_allowed === false) && "No Deviation Allowed"}
                                        //         </span>,
                                        //     ] : [
                                        //         <Tag key={"constitution"} color={"#246079"}>
                                        //             {company &&
                                        //                 CONSTITUTION_TYPES.findKey(_ => _ === company.constitution)}
                                        //         </Tag>
                                        //     ]}
                                        extra={this.caseActions()}
                                    />
                                </Col>
                                {isSectionVisibleByAuthority(this.props.user, ["L1", "L2", "L3", "L4"]) && (
                                <Col span={24} className={`p-base case-detail-summary ${caseDetail && caseDetail.is_deviation_allowed === false && "mt-10"}`}>
                                    <CaseDetailsSummary
                                        userGroups={this.props.userGroups}
                                        user={this.props.user}
                                        fetchCompanyDocuments={(caseId, companyId) => this.updateDocList(caseId, companyId)}
                                        {...(this.isLoading()
                                            ? {}
                                            : caseDetail.getSummary())}
                                        caseType={this.props.currentCaseType}
                                        caseId={this.props.caseId}
                                        companyId={this.props.companyId}
                                        company={this.props.company}
                                        recreditViewOnlyPermission={recreditViewOnlyPermission}
                                        stageId={this.props.stageId}
                                        permissions={this.props.permissions}
                                        data={this.props.caseDetail}
                                        tenor={this.props.caseDetail && this.props.caseDetail.tenure || "--"}
                                        scheme_roi={this.props.caseDetail && this.props.caseDetail.scheme_roi || "--"}
                                        stop_billing_days={this.props.caseDetail && this.props.caseDetail.stop_billing_days || "--"}
                                        stageName={this.props.stageName}
                                        caseTaskId={this.props.case_task_id}
                                        isInbox={this.props.is_inbox}
                                        proposed_limit={
                                            this.props.proposed_limit
                                        }
                                        asm_data={
                                            this.props.caseDetail && this.props.caseDetail.get("sales_manager_user")
                                            // this.state.asm_data
                                        }
                                        isp_data={
                                            this.props.caseDetail && this.props.caseDetail.get("inside_sales_personnel")
                                        }
                                        sales_manager_users={
                                            this.state.sales_manager_users
                                        }
                                        inside_sales_persons={
                                            this.state.inside_sales_persons
                                        }
                                        limit_basis_sales_display={this.props.caseDetail && this.props.caseDetail.limit_basis_sales_display}
                                        parent_fi_movement_cases={this.props.caseDetail && this.props.caseDetail.parent_fi_movement_cases}
                                        child_fi_movement_cases={this.props.caseDetail && this.props.caseDetail.child_fi_movement_cases}
                                        risk_sharing_percentage={this.props.caseDetail && this.props.caseDetail.risk_sharing_percentage}
                                        is_high_value_case={this.props.caseDetail && this.props.caseDetail.is_high_value_case}
                                        caseDetailFields={this.props.caseDetailFields}
                                        caseDetailFieldsStatus={this.props.caseDetailFieldsStatus}
                                        fetchCaseDetailFields={this.props.fetchCaseDetailFields}
                                        currentCaseType={this.props.currentCaseType}
                                        // casesList={this.state.casesList}
                                        callAsmList={this.callAsmList}
                                        callISPList={this.callISPList}
                                        // dbViewTableData={this.state.dbViewTableData}
                                        files={this.props.files}
                                        fetchCaseDetail={this.props.fetchCaseDetail}
                                        portfolioViewData={this.props.portfolioViewData}
                                        portfolioViewStatus={this.props.portfolioViewStatus}
                                        fetchPortfolioView={this.props.fetchPortfolioView}
                                        groupInfoRefreshKey={this.state.groupInfoRefreshKey}
                                        onGroupInfoUpdated={this.handleGroupInfoUpdated}
                                    />
                                </Col>
                                )}
                                <CaseDetails
                                    user={this.props.user.getIn(['data', 'id'], '')}
                                    currentUser={this.props.user}
                                    userGroups={this.props.userGroups}
                                    closeDrawer={this.onDrawerClose}
                                    className={"p-10"}
                                    caseDetail={caseDetail}
                                    caseSanction={caseSanction}
                                    toggleExpand={this.toggleExpand}
                                    caseId={caseId}
                                    companyId={companyId}
                                    isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                                    tab={tab}
                                    history={history}
                                    upgradeCaseButtonsEnabled={
                                        this.upgradeCaseButtonsEnabled
                                    }
                                    // isRiskApprover={this.state.isRiskApprover}
                                    company={this.props.company}
                                    isDisbursedStage={this.props.stageId === 17 && this.props.isUserAllowedToEdit}
                                    isAnchor={caseDetail && caseDetail.process === 1}
                                    match={match}
                                    location={location}
                                    stageId={this.props.stageId}
                                    stageName={this.props.stageName}
                                    caseTaskId={this.props.case_task_id}
                                    getActionModal={this.getActionModal}
                                    openDocView={this.openDocumentsDrawer}
                                    viewCaseNotes={this.viewCaseNotes}
                                    caseAssociatesStatus={this.props.caseAssociatesStatus}
                                    caseAssociates={this.props.caseAssociates}
                                    recreditViewOnlyPermission={recreditViewOnlyPermission}

                                    postSanctionPermission={postSanctionPermission}
                                    // dbViewTableData={this.state.dbViewTableData}
                                    // anchorViewTableData={this.state.anchorViewTableData}
                                    // geoViewTableData={this.state.geoViewTableData}
                                    stateViewTableData={this.state.stateViewTableData}
                                    all_enums={this.props.all_enums}
                                    camEngineData={this.props.camEngineViewData}
                                    camEngineStatus={this.props.camEngineStatus}
                                    camEngineCommentsData={this.props.camEngineCommentsData}
                                    camEngineCommentsStatus={this.props.camEngineCommentsStatus}
                                    fetchCamEngineView={this.props.fetchCamEngineView}
                                    fetchCamEngineViewComments={this.props.fetchCamEngineViewComments}
                                    fetchCaseDetail={this.props.fetchCaseDetail}
                                    fetchCamEngineStatusLogs={this.props.fetchCamEngineStatusLogs}
                                    camEngineStatusLogsData={this.props.camEngineStatusLogsData}
                                    camEngineStatusLogsStatus={this.props.camEngineStatusLogsStatus}
                                    groupInfoRefreshKey={this.state.groupInfoRefreshKey}
                                    onGroupInfoUpdated={this.handleGroupInfoUpdated}
                                />
                            </Row>
                        </LoaderSkeleton>
                    </Layout>
                    {this.props.children}
                </Drawer>
                <Drawer
                    visible={this.state.showDocuments}
                    title={"Document Viewer"}
                    closable
                    placement={"right"}
                    destroyOnClose
                    onClose={this.closeDocumentsDrawer}
                    height={"100vh"}
                    width={"40vw"}
                    maskClosable
                >
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            overflow: "scroll"
                        }}
                    >
                        {this.state.documentsList &&
                            this.state.documentsList.size
                            ? this.state.documentsList
                                .map((_, k) => (
                                    <div
                                        className={"d-flex flex-column"}
                                        key={k}
                                    >
                                        <div
                                            className={
                                                "d-flex justify-content-space-between mb-5"
                                            }
                                        >
                                            {/* <span>{}</span> */}
                                            <span>
                                                <a target={"_blank"} rel={"noreferrer"} href={_}>
                                                    View in another tab
                                                </a>{" "}
                                            </span>
                                        </div>
                                        <DocumentViewer
                                            url={_.file}
                                            companyId={this.props.companyId}
                                            width={"100%"}
                                            height={"500"}
                                            documentName={_.fileName}
                                        />
                                    </div>
                                ))
                                .toList()
                                .toArray()
                            : null}
                    </div>
                </Drawer>
            </React.Fragment>
        );
    }
}

CaseDetailsDrawer.defaultProps = {
    status: STATE_STATUS.UNFETCHED,
    supplyChainDetail: new SupplyChainRecord(),
    caseSanction: new CaseSanctionRecord(),
};

CaseDetailsDrawer.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    action: PropTypes.string,
    companyId: PropTypes.number,
    company: PropTypes.object,
    companyStatus: PropTypes.object,
    caseId: PropTypes.number,
    tab: PropTypes.string,
    name: PropTypes.string,
    status: PropTypes.string,
    caseDetail: PropTypes.object,
    fetchCaseDetail: PropTypes.func,
    fetchCompanyProfile: PropTypes.func,
    initiateCaseState: PropTypes.func,
    //Routing State
    history: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object,
    //
    supplyChainDetail: PropTypes.object,
    caseSanction: PropTypes.object,
    stagePermissions: PropTypes.object,
    stageId: PropTypes.number,
    stageName: PropTypes.string,
    stages: PropTypes.object,
    case_task_id: PropTypes.number,
    is_inbox: PropTypes.bool,
    children: PropTypes.array,
    proceedCase: PropTypes.func,
    referCase: PropTypes.func,
    rejectCase: PropTypes.func,
    user: PropTypes.object,
    userStatus: PropTypes.string,
    upgradedCasesStatus: PropTypes.string,
    proposed_limit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    userGroups: PropTypes.array,
    isUserAllowedToEdit: PropTypes.bool,
    currentStageUser: PropTypes.number,
    updateCaseType: PropTypes.func,
    isCaseUnAssigned: PropTypes.bool,
    assignCase: PropTypes.func,
    assignedUsers: PropTypes.array,
    isCaseRejectedOrHold: PropTypes.bool,
    currentCaseType: PropTypes.number,
    isParentCaseExist: PropTypes.bool,
    cases: PropTypes.object,
    caseOpenedFromDrawer: PropTypes.bool,
    currentCaseTask: PropTypes.object,
    stageAdminIds: PropTypes.array,
    fetchCaseAssociates: PropTypes.func,
    caseAssociatesStatus: PropTypes.string,
    caseAssociates: PropTypes.array,
    caseBankAccountsStatus: PropTypes.string,
    caseBankAccounts: PropTypes.array,
    fetchCaseBankAccounts: PropTypes.func,
    asm_data: PropTypes.object,
    callAsmList: PropTypes.func,
    permissions: PropTypes.object,
    isp_data: PropTypes.object,
    GstinsearchList: PropTypes.string,
    updateCaseAssociateStatus: PropTypes.func,
    deleteAssociateStatus: PropTypes.string,
    camEngineStatus: PropTypes.string,
    camEngineViewData: PropTypes.object,
};

const mapStateToProps = (
    state,
    { location: { state: lState }, match: { params }, props }
) => {
    const companyId = state.caseDetails &&
        state.caseDetails.getIn([Number(params.caseId), "data", "company"]);
    const user = state.user.getIn(["data", "id"]);
    const adminGroup = state.user.getIn(["data", "stage_admin"]);
    const caseDetail = state.caseDetails.getIn([Number(params.caseId), "data"]);
    // Keyed off loaded tasks, NOT status === "FETCHED". The reducer's stale-while-
    // revalidate keeps `data` populated across a refetch and only flips status to
    // FETCHING, and the skeleton stays hidden in that window — so gating on status
    // made current_case_task `false` mid-refetch. That made stageId `false`, and
    // String(false) === "false" is a stage the proceed checklist has no entry for,
    // which blanked the whole screen. It also nulled every prop below that reads
    // current_case_task (isUserAllowedToEdit, currentStageUser, stageName...).
    // The length check is what the status gate was really buying us:
    // getCurrentCaseTask ends in `current_case_task[0]`, which throws on the
    // empty first-load record.
    const current_case_task =
        caseDetail && caseDetail.current_case_task && caseDetail.current_case_task.length
            ? caseDetail.getCurrentCaseTask(user, adminGroup)
            : null;
    return {
        caseOpenedFromDrawer: lState && lState.case_details && lState.case_details.caseOpenedFromDrawer,
        caseId: Number(params.caseId),
        cases: state.cases,
        user: state.user,
        userGroups: state.user && state.user.getIn(["data", "groups"]).map(_ => _.id),
        userStatus: state.user.get("status"),
        case_task_id:
            current_case_task && current_case_task.id,
        currentStageUser: current_case_task && current_case_task.this_user && current_case_task.this_user.id,
        isUserAllowedToEdit:
            state.user &&
            current_case_task &&
            current_case_task.this_user &&
            current_case_task.this_user.id === state.user.getIn(["data", "id"]) &&
            ![2, 4, 5].includes(caseDetail && caseDetail.case_status),
        is_inbox: location.pathname.includes("inbox"),
        tab: params.tabId,
        action: CASE_VIEW_ACTION,
        name: state.companies.getIn([companyId, "data", "name"]),
        status: params.caseId
            ? state.caseDetails.getIn([Number(params.caseId), "status"])
            : null,
        companyId: companyId,
        companyStatus:
            companyId ?
                state.companies.getIn([
                    companyId,
                    "status"
                ])
                : null,
        company:
            companyId
                ? state.companies.getIn([companyId, "data"])
                : null,
        caseDetail: params.caseId
            ? state.caseDetails.getIn([Number(params.caseId), "data"])
            : null,
        stageId: current_case_task && current_case_task.this_stage,
        stageName:
            current_case_task
                ? (
                    state.stages
                        .get("data")
                        .find(_ => _.id === current_case_task.this_stage) || {
                        stage_name: null
                    }
                ).stage_name
                : null,
        assignedUsers: state.caseDetails.getIn([Number(params.caseId), "data", "current_case_task"]),
        isCaseUnAssigned: !!(state.caseDetails.getIn([Number(params.caseId), "data", "current_case_task"]) || [{ this_user: null }]).find(_ => !_.this_user),
        isCaseRejectedOrHold: [2, 4, 5].includes(state.caseDetails.getIn([Number(params.caseId), "data", "case_status"])),
        currentCaseType: state.caseDetails.getIn([Number(params.caseId), "data", "case_type"]),
        stagePermissions: state.stagePermissions,
        permissions: state.user.getIn(["permissions"]),
        stages: state.stages.get("data"),
        proposed_limit: state.caseDetails.getIn([
            Number(params.caseId),
            "data",
            "proposed_limit"
        ]),
        upgradedCasesStatus: state.upgradedCases.get(
            current_case_task && current_case_task.id
        ),
        isParentCaseExist: !!state.caseDetails.getIn([Number(params.caseId), "data", "parent_case_detail"]),
        currentCaseTask: current_case_task,
        stageAdminIds: state.user.getIn(["data", "stage_admin"]),
        caseAssociatesStatus: state.caseDetails.getIn([Number(params.caseId), "caseAssociates", "status"]),
        caseAssociates: state.caseDetails.getIn([Number(params.caseId), "caseAssociates", "data"]),
        caseBankAccountsStatus: state.caseDetails.getIn([Number(params.caseId), "caseBankAccounts", "status"]),
        caseDetailFields: state.caseDetails.getIn([Number(params.caseId), "caseDetailFields", "data"]),
        caseDetailFieldsStatus: state.caseDetails.getIn([Number(params.caseId), "caseDetailFields", "status"], STATE_STATUS.UNFETCHED),
        caseBankAccounts: state.caseDetails.getIn([params.caseId, "caseBankAccounts", "data"]),
        gstinSearchListStatus: state.caseDetails.getIn([params.caseId, "gstinSearchListStatus"]),
        deleteAssociateStatus: state.caseDetails.getIn([Number(params.caseId), "caseAssociates", "deleteAssociateStatus"]),
        files: state.documents
            .getIn(["company_documents", companyId, "data"], Map({}))
            .map(_ => _.get("data"))
            .filter(_ => _.is_active)
            .sort((a, b) => (a.modified_date.isBefore(b.modified_date) ? 1 : -1))
            .toList(),
        all_enums: state.companies.get("enums"),
        camEngineStatus: state.companyLosProfiles.get("camEngineStatus"),
        camEngineViewData: state.companyLosProfiles.getIn(["camEngineData", Number(params.caseId)]),
        camEngineCommentsStatus: state.companyLosProfiles.get("camEngineCommentsStatus"),
        camEngineCommentsData: state.companyLosProfiles.getIn(["camEngineCommentsData", Number(params.caseId)]),
        camEngineStatusLogsStatus: state.companyLosProfiles.get("camEngineStatusLogsStatus"),
        camEngineStatusLogsData: state.companyLosProfiles.getIn(["camEngineStatusLogsData", Number(params.caseId)]),
        portfolioViewData: state.companyLosProfiles.getIn(["portfolioViewData", Number(params.caseId)]),
        portfolioViewStatus: state.companyLosProfiles.get("portfolioViewStatus"),

    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCompanyDocuments,
            fetchCaseDetail,
            fetchCompanyProfile,
            initiateCaseState,
            proceedCase,
            referCase,
            rejectCase,
            updateCaseType,
            assignCase,
            fetchCaseAssociates,
            fetchCaseBankAccounts,
            fetchCaseDetailFields,
            GstinsearchList,
            updateCaseAssociateStatus,
            fetchEnums,
            fetchCamEngineView,
            fetchPortfolioView,
            fetchCamEngineViewComments,
            fetchCamEngineStatusLogs
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CaseDetailsDrawer);
